const ecRecommendationTypes = {
    SHORT_SESSION: 'short_session',
    FREQUENT_LIMITATION: 'frequent_limitation',
    DEVICE_OVERHEATING: 'device_overheating',
};

export default ecRecommendationTypes;
